import { render, staticRenderFns } from "./UserIncentive.vue?vue&type=template&id=104ad18c"
import script from "./UserIncentive.vue?vue&type=script&lang=js"
export * from "./UserIncentive.vue?vue&type=script&lang=js"
import style0 from "./UserIncentive.vue?vue&type=style&index=0&id=104ad18c&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/myapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('104ad18c')) {
      api.createRecord('104ad18c', component.options)
    } else {
      api.reload('104ad18c', component.options)
    }
    module.hot.accept("./UserIncentive.vue?vue&type=template&id=104ad18c", function () {
      api.rerender('104ad18c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/pages/UserIncentive.vue"
export default component.exports